import { BrowseActionTypes } from "../models/browseActions";
import { CLEAR_FILTERS } from "../types";

export default (): BrowseActionTypes => ({
    type: CLEAR_FILTERS,
});
